
export const initialValues = {
  vehicleCatName: "",
  vehicleCatCode: "",
  transportModeId: "",
  activeStatus: 1,

}